import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Logo from "../../assets/img/g246.png";
import LogoWhite from "../../assets/img/BUENA RUTA - ISOLOGO 3 BLANCO.png";

const LogLogoImg = styled.img`
  height: 48px;
  width: auto;
  cursor: pointer;
`;
const LogLogo = (props) => {
  const history = useHistory();
  return (
    <LogLogoImg
      {...props}
      onClick={() => history.push("/")}
      src={props.light ? LogoWhite : Logo}
    />
  );
};

export default LogLogo;
